/**
 * Keeps last_seen_at fresh while the agent is signed in, including Away.
 */
export class AgentLastSeenHeartbeat {
  /**
   * @param {() => Promise<unknown>} ping
   * @param {number} [intervalMs]
   */
  constructor(ping, intervalMs = 25_000) {
    this._ping = ping;
    this._intervalMs = intervalMs;
    this._timer = null;
  }

  start() {
    this.stop();
    void this._safePing();
    this._timer = setInterval(() => {
      void this._safePing();
    }, this._intervalMs);
  }

  stop() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  async _safePing() {
    try {
      await this._ping();
    } catch {
      /* transient */
    }
  }
}
